import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { StoreService } from 'src/app/core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { AppClient } from 'src/app/core/app.client';
import { Term } from 'src/app/models/term.model';

@Component({
  selector: 'signature',
  templateUrl: './signature.component.html',
})
export class SignatureComponent implements OnInit, AfterViewInit {
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 750,
    'canvasHeight': 300
  };

  title = 'signature.title';
  isStaff = this.store.state.isStaff;
  text = '';
  progressBar = '100%';
  fullName: string = !this.isStaff
    ? `${this.store.state.consent.guardians[0].firstName} ${this.store.state.consent.guardians[0].lastName}`
    : `${this.store.state.consent.student.firstName} ${this.store.state.consent.student.lastName}`;
  term: Term = {
    id: '',
    english: '',
    spanish: ''
  };

  constructor(private router: Router,
    private translate: TranslateService,
    private store: StoreService,
    private navigation: NavigationService,
    private client: AppClient) { }

  ngOnInit(): void {
    this.client.getLatestTerm()
      .subscribe(term => {
        this.term = term;

        switch (this.translate.currentLang) {
          case 'en': {
            this.text = this.term.english;
            break;
          }
          case 'es': {
            this.text = this.term.spanish;
            break;
          }
          default: {
            this.text = this.term.english;
            break;
          }
        }
      });
  }

  ngAfterViewInit(): void {
    this.setupSignaturePad();
  }

  setupSignaturePad() {
    var container = document.getElementById('canvas-container');

    // Use a fixed drawing height instead of the container height. On mobile the
    // Clear button stacks above the canvas (float-lg-right only applies on large
    // screens), so container.offsetHeight includes the button and made the canvas
    // overflow downward, covering the "Accept" button and capturing its taps as
    // drawing events. See signaturePadOptions.canvasHeight.
    this.signaturePad.set('canvasWidth', container.offsetWidth - 40);
    this.signaturePad.set('canvasHeight', this.signaturePadOptions['canvasHeight']);

    // Recommended for touch devices so touch input is treated as drawing, not
    // scrolling, and doesn't leak to elements underneath.
    const canvas = container.querySelector('canvas');
    if (canvas) {
      canvas.style.touchAction = 'none';
    }
  }

  clear() {
    this.signaturePad.clear();
  }

  back() {
    this.router.navigate([this.navigation.signature.back]);
  }

  submit() {
    this.store.state.consent.signature.termId = this.term.id;
    this.store.state.consent.signature.fullName = this.fullName;

    const image = this.signaturePad.toDataURL().replace('data:image/png;base64,', '');
    this.store.state.consent.signature.image = image;

    this.client.addConsent()
      .subscribe();
    this.router.navigate([this.navigation.signature.next]);
  }
}
